import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MsModalComponent } from './ms-modal.component';

@NgModule({
  imports: [CommonModule],
  exports: [MsModalComponent],
  declarations: [MsModalComponent],
  providers: [],
})
export class MsModalModule {}
